<template>
  <div class="top-bar-shell" :class="{ 'top-bar-shell--mobile-header': mobileHeader }">
    <div class="top-bar-shell__title">
      <slot name="title">
        <ItemName v-if="!isMobile" />
      </slot>
    </div>
    <div class="top-bar-shell__actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script setup lang="ts">
import ItemName from '@/modules/viewer/components/Name.vue';
import { useMobileDetection } from '@/composables/useMobileDetection';

withDefaults(
  defineProps<{
    /** Opt into placement within ViewerLayoutRoot's reserved mobile navigation row. */
    mobileHeader?: boolean;
  }>(),
  { mobileHeader: false }
);

const { isMobile } = useMobileDetection();
</script>

<style scoped>
.top-bar-shell {
  @apply flex flex-row items-center justify-end gap-1;
}

@media (max-width: 639px) {
  .top-bar-shell--mobile-header {
    position: absolute;
    top: 0.5rem;
    right: 1rem;
    z-index: 50;
  }
}

@media (min-width: 640px) {
  .top-bar-shell {
    @apply justify-between gap-2;
  }
}

.top-bar-shell__title {
  @apply hidden sm:block flex-1 min-w-0;
}

.top-bar-shell__title :deep(h1),
.top-bar-shell__title :deep([data-testid='viewer-item-name']) {
  @apply text-xl sm:text-2xl font-semibold truncate;
}

.top-bar-shell__actions {
  @apply flex items-center gap-1 sm:gap-2 flex-shrink-0;
}
</style>
